import { render } from "./FpTreeEdit.vue?vue&type=template&id=6c0b88a4"
import script from "./FpTreeEdit.vue?vue&type=script&lang=js"
export * from "./FpTreeEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__